import { useState } from 'react';
import {
  Control,
  Controller,
  FieldValues,
  Path,
} from "react-hook-form";
import { ColorPickerComponent } from "../common/ColorPicker";
import { Button } from '../ui/button';
import { Popover, PopoverContent, PopoverTrigger } from '../ui/popover';

interface ControlledColorPickerProps<T extends FieldValues> {
  name: Path<T>;
  control: Control<T>;
  label?: string;
}

const ControlledColorPicker = <T extends FieldValues>({
  name,
  control,
  label,
}: ControlledColorPickerProps<T>) => {
  const [open, setOpen] = useState(false);

  return (
    <div className="flex flex-col gap-2">
      {label && <div className="text-sm text-gray-700">{label}</div>}
      <Controller
        name={name}
        control={control}
        render={({ field }) => (
          <Popover open={open} onOpenChange={setOpen}>
            <PopoverTrigger asChild>
              <Button
                variant="outline"
                className="w-full justify-start text-left font-normal h-10"
              >
                <div className="flex items-center gap-2">
                  <div
                    className="w-6 h-6 rounded border border-gray-200"
                    style={{
                      backgroundColor: field.value ? `#${field.value}` : '#FFFFFF',
                    }}
                  />
                  <span className="text-gray-500">#</span>
                  <span>{field.value || 'FFFFFF'}</span>
                </div>
              </Button>
            </PopoverTrigger>
            <PopoverContent className="w-auto p-0" align="start">
              <ColorPickerComponent
                value={field.value ? `#${field.value}` : '#FFFFFF'}
                onChange={(color) => {
                  field.onChange(color.replace('#', ''));
                }}
                onClose={() => setOpen(false)}
              />
            </PopoverContent>
          </Popover>
        )}
      />
    </div>
  );
} 

export { ControlledColorPicker };
